import { render } from "./TeamPage.vue?vue&type=template&id=289c9716&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-289c9716"

export default script